import React from "react";
import { warranty } from "../data/site";

// The workmanship warranty seal.
//
// The art has the term baked into it, so this component refuses to render if
// `warranty.laborYears` is not the term on the badge. That sounds pedantic
// until you remember the certificate shipped with a "15 YEARS" stat box for a
// while after the term moved to twenty-five — a number drawn as artwork is
// exactly the kind that rots silently. If the term changes, new art is
// needed, and until it exists the site should say nothing rather than
// something wrong.
export const BADGE_TERM = "25";

const SRC = "/images/warranty-badge-25";

/**
 * @param {number} size   rendered width/height in CSS px (the file is 640²)
 * @param {boolean} eager skip lazy-loading — only for a badge above the fold
 * @param {string} className extra classes on the <picture>
 */
const WarrantyBadge = ({ size = 200, eager = false, className = "" }) => {
  if (warranty.laborYears !== BADGE_TERM) return null;

  const alt = `Pepla Roofing ${BADGE_TERM}-year workmanship warranty seal`;

  return (
    <picture className={`block shrink-0 ${className}`}>
      <source srcSet={`${SRC}.webp`} type="image/webp" />
      <img
        src={`${SRC}.png`}
        alt={alt}
        width={size}
        height={size}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        // Intrinsic width/height above reserve the box; this keeps it fluid
        // inside a narrower column without letting it outgrow `size`.
        style={{ width: "100%", maxWidth: size, height: "auto" }}
        className="select-none"
        draggable="false"
      />
    </picture>
  );
};

export default WarrantyBadge;
